var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine67(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 77",
    overflow: "scroll",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    fill: "#FF82B4",
    width: 120,
    height: 77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.7519989,69.8173828c-16.338398,0-22.1796989-11.3437843-22.1796989-27.1747818 c0-20.7407017,9.7353001-35.6402016,28.8675995-35.6402016c3.3862991,0,6.4336014,0.4233999,8.9737015,1.0162005 l-1.8628006,10.1585999C52.9424019,17.5,49.8101006,16.7378006,46.3394012,16.7378006 c-8.3809013,0-14.4761009,6.6879997-15.3228016,18.7094994c2.031702-1.7784004,5.9258022-4.0634995,12.3598995-4.0634995 c9.9048004,0,17.8618011,6.517601,17.8618011,17.6923981C61.2383003,61.0126991,53.2812996,69.8173828,40.7519989,69.8173828z M39.5668983,40.7803001c-3.809597,0-6.8568993,1.4393997-8.0424976,3.3017006 c-0.6772003,1.0156975-0.6772003,3.3857994-0.6772003,5.1641006c0,5.6718979,3.3016987,11.1737976,9.3968983,11.1737976 c5.9258003,0,8.9737015-4.8251991,8.9737015-9.9892006C49.2178001,44.8437004,45.4926987,40.7803001,39.5668983,40.7803001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8867035,68.3779297H69.2577972c0-7.8730278,2.1162033-12.9521294,7.3652039-22.6875305l14.5606003-27.0897999 H62.1464996V8.6107998h41.8202972v9.7354012C90.8447037,41.1190987,82.8867035,58.9813995,82.8867035,68.3779297z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine67);
export default __webpack_public_path__ + "static/media/line-67.0dc7a6602167f810c4c81e60e71026a7.svg";
export { ForwardRef as ReactComponent };